module.exports = __webpack_public_path__ + "static/img/7.4e59048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/7.png
// module id = zx5w
// module chunks = 38